namespace RioERP.Masters {
    export interface TaxTypesForm {
        Name: Serenity.StringEditor;
    }

    export class TaxTypesForm extends Serenity.PrefixedContext {
        static formKey = 'Masters.TaxTypes';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!TaxTypesForm.init)  {
                TaxTypesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(TaxTypesForm, [
                    'Name', w0
                ]);
            }
        }
    }
}
